import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Dialog } from 'functional-foundations'
import { useThemeContext } from 'providers'
import { Typography, Button } from 'foundations-library/components'
import { getRemoteValue } from '../utils'

const jss = () => ({
    root: {
        '& .dialog-container': {
            padding: '40px 30px 50px'
        },
        '& .dialog-content': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '80px',
            paddingTop: '40px',
            paddingBottom: '40px',
            paddingLeft: '30px',
            paddingRight: '30px'
        }
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '50px'
    },
    typography: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px'
    },
    title: {
        fontWeight: 600,
        fontStyle: 'Semi Bold',
        fontSize: '30px',
        lineHeight: '38px',
        letterSpacing: '-0.3px'

    },
    subtitle: {
        fontWeight: 400,
        fontStyle: 'Regular',
        fontSize: '18px',
        lineHeight: '26px',
        letterSpacing: '-0.2px'
    }
})

const useStyles = makeStyles(jss)

/**
 *
 */
const PasswordUpdated = ({ hasSignedOut = true, open = false, onClose, buttonText = null }: { hasSignedOut?: boolean, open:boolean, onClose:()=>void, buttonText:Text}) => {
    const classes = useStyles()
    const theme = useThemeContext()
    const [isOpen, setIsOpen] = useState(open)

    const texts = hasSignedOut ? getRemoteValue('sign_out') : getRemoteValue('password_updated')

    const handleClose = () => {
        setIsOpen(false)
        console.log('close-from-inside')
        onClose()
    }

    return (
        <Dialog className={classes.root} isOpen={isOpen} data-testid={'logout-dialog'}>
            <div className={classes.content}>
                <img src={theme?.icons?.identityAreaLogo} alt='brand logo' style={{ width: '100px', height: '100px' }} />
                <div className={classes.typography}>
                    <Typography className={classes.title} variant='h4' color='neutral-900'>{texts.title}</Typography>
                    <Typography className={classes.subtitle} variant='h8' color='neutral-900' align='center'>{texts.subTitle}</Typography>
                </div>
            </div>
            <Button size='large' color='primary' variant='contained' icon={'go'} onClick={handleClose}>{buttonText || texts.button}</Button>
        </Dialog>
    )
}

export default PasswordUpdated
